export default __webpack_public_path__ + "static/Download_on_the_App_Store-6b8111f96d72efae9a273d8524a2dd9e.png";